import { render, staticRenderFns } from "./DocumentStatusModal.vue?vue&type=template&id=5f196c1a&"
import script from "./DocumentStatusModal.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatusModal.vue?vue&type=style&index=0&id=5f196c1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports